import { DetailedHTMLProps, forwardRef, InputHTMLAttributes } from 'react'
import RadioButton from '@/components/common/radio-button/RadioButton'
import Label from '@/components/pages/checkout/booking-page/Label'
import { cx } from '@/lib/utils/utils'
import { getInputBorderStyles } from '@/components/pages/checkout/booking-page/booking-form/BookingFormInputElement'

interface RadioButtonWithLabelProps
  extends DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  labelValue: string
  error?: boolean
  className?: string
  onLabelClick?: () => void
}

const RadioButtonWithLabel = forwardRef<HTMLInputElement, RadioButtonWithLabelProps>(
  ({ labelValue, className, error, ...props }, ref) => {
    return (
      <Label
        onClick={props.onLabelClick}
        className={cx(
          'flex gap-x-0 align-text-top text-black',
          getInputBorderStyles(!!error),
          className,
        )}
        inputElement={<RadioButton {...props} ref={ref} />}
      >
        <div>{labelValue}</div>
      </Label>
    )
  },
)

export default RadioButtonWithLabel
